// Colored initials avatar for team members (CLE-257). Draws the profile
// photo instead when the person has one (found by user id or name in the
// team directory — `id` here is usually a Person id, hence the separate prop).
import { useAvatarSrc } from '../../hooks/useAvatarDirectory';
import { colorForKey } from './charts';

function initials(name: string): string {
  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

export function Avatar({
  name,
  id,
  size = 36,
  className,
  userId,
  src,
}: {
  name: string;
  /** Stable key for the color (person id). Falls back to the name. */
  id?: string;
  size?: number;
  className?: string;
  userId?: string | null;
  src?: string | null;
}) {
  const color = colorForKey(id ?? name);
  const photo = useAvatarSrc({ src, userId, name });
  if (photo) {
    return (
      <img
        src={photo}
        alt=""
        aria-hidden
        className={`inline-block shrink-0 rounded-full object-cover ${className ?? ''}`}
        style={{ width: size, height: size }}
      />
    );
  }
  return (
    <span
      className={`inline-flex shrink-0 items-center justify-center rounded-full font-semibold text-white ${className ?? ''}`}
      style={{
        width: size,
        height: size,
        fontSize: size * 0.38,
        backgroundColor: `${color}26`,
        color,
        border: `1px solid ${color}55`,
      }}
      aria-hidden
    >
      {initials(name)}
    </span>
  );
}
